import { h } from 'preact'; /** @jsx h */
import './hero.scss';

const Hero = () => {
    return (
        <div className="ws-hero">
            <div className="ws-hero-content">
                <h1 className="ws-hero-title">Nettbutikk for Stiftelsen Norsk Luftambulanse</h1>
                <p className="ws-hero-subtitle">
                    Alle produktene samlet på ett sted. Kjøp produkter til deg selv eller noen du er
                    glad, og støtt viktig arbeid for å redde liv.
                </p>
                <ul className="ws-hero-list">
                    <li className="ws-hero-list-item">
                        <span className="ws-hero-list-item-icon material-symbols-outlined">
                            check_circle
                        </span>
                        <span className="ws-hero-list-item-text">Betaling med Vipps</span>
                    </li>
                    <li className="ws-hero-list-item">|</li>
                    <li className="ws-hero-list-item">
                        <span className="ws-hero-list-item-icon material-symbols-outlined">
                            check_circle
                        </span>
                        <span className="ws-hero-list-item-text">Gratis frakt</span>
                    </li>
                    <li className="ws-hero-list-item">|</li>
                    <li className="ws-hero-list-item">
                        <span className="ws-hero-list-item-icon material-symbols-outlined">
                            check_circle
                        </span>
                        <span className="ws-hero-list-item-text">Levering i postkasse</span>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default Hero;
